module.exports = __webpack_public_path__ + "media/images/logo-e00aa1115a773e10ab1c7c3caa60b194.svg";